import { useQuery } from '@tanstack/react-query';
import { useUserPreferences } from '@/contexts/UserPreferencesContext';
import { getReportDocument, type ReportParams } from '@/services/reportDocuments.service';

/** Loads a server report document; `params === null` keeps the query idle until filters are complete. */
export function useReportDocument(reportKey: string, params: ReportParams | null) {
  const { preferences } = useUserPreferences();
  const documentLanguage = preferences?.document_language || 'en';
  const merged =
    params == null
      ? null
      : ({
          ...params,
          // Explicit param wins; otherwise preference drives PDF/print language (≠ UI language).
          document_language: (params as ReportParams).document_language ?? documentLanguage,
        } as ReportParams);

  return useQuery({
    queryKey: ['report-document', reportKey, merged],
    queryFn: () => getReportDocument(reportKey, merged as ReportParams),
    enabled: !!merged,
    staleTime: 30_000,
  });
}
